import script from "./PrivateNewProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateNewProduct.vue?vue&type=script&setup=true&lang=js"

import "./PrivateNewProduct.vue?vue&type=style&index=0&id=271a62e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271a62e8"]])

export default __exports__